export default {
      id: "uber-usage",
      viewBox: "0 0 62.056 47.236",
      url: "../../assets/" + "sprite.svg#uber-usage",
      toString: function () {
        return this.url;
      }
    }